import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { PatternsListResponse, UpdatePatternInput } from "@money/shared";
import { apiFetch } from "./client";

export const patternsKey = ["patterns"] as const;

export function usePatterns() {
  return useQuery({
    queryKey: patternsKey,
    queryFn: () => apiFetch<PatternsListResponse>("/patterns"),
    staleTime: 60_000,
  });
}

export function useRefreshPatterns() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<PatternsListResponse>("/patterns/refresh", { method: "POST" }),
    onSuccess: (data) => qc.setQueryData(patternsKey, data),
  });
}

export function useUpdatePattern() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; patch: UpdatePatternInput }) =>
      apiFetch<void>(`/patterns/${input.id}`, { method: "PATCH", body: input.patch }),
    onSuccess: () => qc.invalidateQueries({ queryKey: patternsKey }),
  });
}
